var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:(_vm.showMessageBar?'':'d-none') + '  message-bar'},[_c('div',{class:_vm.messageClass},[_c('Button',{staticClass:"btn btn-link close-btn",attrs:{"bsStyle":"link"},on:{"click":_vm.closeMessageBar}},[_c('i',{staticClass:"fa fa-times"})]),_c('div',[_vm._v(_vm._s(_vm.currentMessage))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }